import React, { useState } from "react"

import {
	MoreVert as MoreOptionsIcon,
	Settings as ConfigIcon
} from "@material-ui/icons"
import { Kanban as BoardIcon } from "lucide-react"

import {
	Grid,
	IconButton,
	ListItemText,
	Menu,
	MenuItem,
	Typography
} from "@material-ui/core"
import { themeColors } from "letalkui"

import TriggerItemContainer from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/TriggerItemContainer"
import TagChip from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/TagChip"

import { ConstructionResources, TriggerItemProps } from "@/protocols/chatBotConstructor"

import ClientAddedToFunnelEditorDialog from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/resources/Nodes/TriggerNode/TriggerItem/ClientAddedToFunnelTriggerItem/ClientAddedToFunnelEditorDialog"

import useStyles from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/resources/Nodes/TriggerNode/TriggerItem/ClientAddedToFunnelTriggerItem/styles"
import useCustomStyles from "@/styles/custom"

const DEFAULT_RGB_CHIP_COLOR = {
	r: 53,
	g: 140,
	b: 238
}

const ClientAddedToFunnelTriggerItem: React.FC<TriggerItemProps> = (props) => {
	const {
		onDelete,
		trigger,
		loadSpecificConstructionResources,
		changeChatBotFlowTrigger
	} = props

	const classes = useStyles()
	const customClasses = useCustomStyles()

	const [optionsMenuAnchorElement, setOptionsMenuAnchorElement] = useState<null | HTMLElement>(null)

	const handleOpenOptionsDialog = (element: HTMLElement) => {
		setOptionsMenuAnchorElement(element)
	}

	const handleCloseOptionsDialog = () => {
		setOptionsMenuAnchorElement(null)
	}

	return (
		<TriggerItemContainer
			title="Etapa do funil"
			description="Chatbot acionado quando um contato é adicionado em uma etapa do funil"
			icon={<BoardIcon color={themeColors.getPrimaryColor()} />}
			actionBody={(
				<Grid container alignItems="center" className={classes.container}>
					<Grid item xs={10}>
						<Grid container>
							<Grid item xs={3}>
								<Typography className={classes.title}>
									Etapa:
								</Typography>
							</Grid>

							<Grid item xs={9}>
								{trigger.board ? (
									<Grid container>
										<Grid
											item
											key={trigger.board.stage.id}
											style={{
												width: "90%"
											}}
										>
											<TagChip
												color={DEFAULT_RGB_CHIP_COLOR}
												name={trigger.board.stage.name}
												className={`${classes.tagChip} ${customClasses.inlineText}`}
												{...(trigger.board.stage.name.length > 15 && { tooltip: { name: trigger.board.stage.name } })}
											/>
										</Grid>
									</Grid>
								) : (
									<Grid container>
										<Typography
											className={classes.title}
											style={{
												paddingLeft: "6px"
											}}
										>
											-
										</Typography>
									</Grid>
								)}
							</Grid>
						</Grid>
					</Grid>
					<Grid item xs>
						<Grid container justifyContent="flex-end">
							<ClientAddedToFunnelEditorDialog
								onLoadBoardStages={async () => {
									const resources = await loadSpecificConstructionResources("boards")

									return resources?.boards as ConstructionResources["boards"]
								}}
								saveText="Salvar"
								trigger={trigger}
								onSave={(boardStage) => {
									if (boardStage) {
										changeChatBotFlowTrigger("UPDATE", {
											...trigger,
											board: {
												id: boardStage.boardId,
												stage: {
													id: boardStage.id,
													name: boardStage.name
												}
											}
										})
									}
								}}
							>
								<IconButton className={classes.iconButton}>
									<ConfigIcon />
								</IconButton>
							</ClientAddedToFunnelEditorDialog>
						</Grid>
					</Grid>
				</Grid>
			)}
		>
			<Grid
				item
				container
				justifyContent="flex-end"
			>
				<IconButton
					onClick={event => handleOpenOptionsDialog(event.target as HTMLElement)}
				>
					<MoreOptionsIcon fontSize="small" />
				</IconButton>
			</Grid>

			<Menu
				anchorEl={optionsMenuAnchorElement}
				keepMounted
				open={Boolean(optionsMenuAnchorElement)}
				onClose={handleCloseOptionsDialog}
				autoFocus={false}
				PaperProps={{
					style: {
						marginTop: 40
					}
				}}
			>
				{onDelete && (
					<MenuItem
						onClick={() => {
							onDelete()
							handleCloseOptionsDialog()
						}}
					>
						<ListItemText primary="Excluir" />
					</MenuItem>
				)}
			</Menu>
		</TriggerItemContainer>
	)
}

export default ClientAddedToFunnelTriggerItem
